<template>
  <div
    class="flex"
    :class="isMobile ? 'flex-wrap justify-center' : 'justify-start'"
  >
    <button
      :id="'nav-button-' + index"
      v-for="(button, index) in buttons"
      :key="index"
      @click="buttonClicked(index)"
      class="font-semibold rounded-full px-2 focus:outline-none "
      :class="getCSS(button, index, active)"
    >
      {{ button }}
    </button>
    <About />
  </div>
</template>

<style scoped></style>

<script>
import { mapMutations } from "vuex";
import { Navigation } from "../models";
import About from "./base/InformationComponent";

export default {
  props: {
    isMobile: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    About,
  },
  data() {
    return {
      buttons: ["All", "Map", "Topic", "Generation", "Gender", "Discipline"],
      // active: 0,
    };
  },
  computed: {
    active() {
      return this.$store.getters.getActiveNavigation;
    },
  },
  methods: {
    ...mapMutations(["setActiveNavigation"]),
    buttonClicked(index) {
      /*    if (index > 2) return; */ // Disable Gender and Discipline for now
      //this.active = index;
      this.setActiveNavigation(index);
      const cName = this.$router.currentRoute.name;
      // Don't push to the same route we are currently on
      if (
        (cName === Navigation.MapView || cName === Navigation.VideoView) &&
        index !== 1
      ) {
        this.$router.push("/");
      } else if (
        (cName === Navigation.GridView || cName === Navigation.VideoView) &&
        index === 1
      )
        this.$router.push("/map");
    },
    getCSS(name, index, active) {
      /*    if (name === "Generation" || name === "Discipline")
        return "cursor-not-allowed hover:bg-red-500"; */
      const css = index === active ? "bg-black text-white" : "bg-white";
      return css + " hover:bg-black hover:text-white";
    },
  },
};
</script>
